import { LeaderboardEntryModel } from '../leaderboard-entry.model';

export class InitLeaderboardAssociation {
  static readonly type = '[Leaderboard] Init Leaderboard Association';
  constructor(
    public payload: { projectId: string; puzzleName: string; puzzleId: string; wantLeaderboardRules: boolean }
  ) {}
}

export class UseHelper {
  static readonly type = '[Leaderboard] Use Helper';
  constructor(public payload: { projectId: string; puzzleName: string; puzzleId: string; helperUsed: string }) {}
}

export class SavePostedEntry {
  static readonly type = '[Leaderboard] Save Entry';
  constructor(
    public payload: {
      projectId: string;
      puzzleName: string;
      puzzleId: string;
      submittedEntry: LeaderboardEntryModel;
      submittedEntryUUID;
    }
  ) {}
}

export class SetFinished {
  static readonly type = '[Leaderboard] Set Finished';
  constructor(public payload: { projectId: string; puzzleName: string; puzzleId: string }) {}
}
